import { useState } from "react";

// Full corridors based on Grid API documentation
const corridors = [
  // USD source
  { from: "USD", to: "EUR", rails: ["SEPA", "SEPA Instant", "UMA"], countries: "32 European countries" },
  { from: "USD", to: "GBP", rails: ["IBAN", "Faster Payments", "UMA"], countries: "United Kingdom" },
  { from: "USD", to: "BRL", rails: ["PIX", "UMA"], countries: "Brazil" },
  { from: "USD", to: "MXN", rails: ["CLABE", "UMA"], countries: "Mexico" },
  { from: "USD", to: "INR", rails: ["UPI", "UMA"], countries: "India" },
  { from: "USD", to: "NGN", rails: ["NGN Account"], countries: "Nigeria" },
  { from: "USD", to: "GHS", rails: ["GHS Account"], countries: "Ghana" },
  { from: "USD", to: "KES", rails: ["KES Account"], countries: "Kenya" },
  { from: "USD", to: "ZAR", rails: ["ZAR Account"], countries: "South Africa" },
  { from: "USD", to: "UGX", rails: ["UGX Account"], countries: "Uganda" },
  { from: "USD", to: "TZS", rails: ["TZS Account"], countries: "Tanzania" },
  { from: "USD", to: "XOF", rails: ["XOF Account"], countries: "WAEMU (8 countries)" },
  { from: "USD", to: "XAF", rails: ["XAF Account"], countries: "CEMAC (6 countries)" },
  { from: "USD", to: "PHP", rails: ["PHP Account"], countries: "Philippines" },
  { from: "USD", to: "SGD", rails: ["PayNow"], countries: "Singapore" },
  { from: "USD", to: "IDR", rails: ["IDR Account"], countries: "Indonesia" },
  { from: "USD", to: "THB", rails: ["PromptPay"], countries: "Thailand" },
  { from: "USD", to: "VND", rails: ["VND Account"], countries: "Vietnam" },
  { from: "USD", to: "PKR", rails: ["PKR Account"], countries: "Pakistan" },
  { from: "USD", to: "BDT", rails: ["BDT Account"], countries: "Bangladesh" },
  { from: "USD", to: "CAD", rails: ["CAD Account"], countries: "Canada" },
  { from: "USD", to: "CRC", rails: ["SINPE"], countries: "Costa Rica" },
  { from: "USD", to: "BTC", rails: ["Lightning", "Spark"], countries: "Global" },
  { from: "USD", to: "USDC", rails: ["Solana", "Base", "Polygon"], countries: "Global" },
  { from: "USD", to: "USDT", rails: ["Tron"], countries: "Global" },
  // EUR source
  { from: "EUR", to: "USD", rails: ["US Account", "RTP", "UMA"], countries: "United States" },
  { from: "EUR", to: "GBP", rails: ["IBAN", "UMA"], countries: "United Kingdom" },
  { from: "EUR", to: "BRL", rails: ["PIX"], countries: "Brazil" },
  { from: "EUR", to: "BTC", rails: ["Lightning", "Spark"], countries: "Global" },
  { from: "EUR", to: "USDC", rails: ["Solana", "Base", "Polygon"], countries: "Global" },
  // GBP source
  { from: "GBP", to: "USD", rails: ["US Account", "UMA"], countries: "United States" },
  { from: "GBP", to: "EUR", rails: ["SEPA", "UMA"], countries: "Europe" },
  { from: "GBP", to: "BTC", rails: ["Lightning", "Spark"], countries: "Global" },
  // BTC source
  { from: "BTC", to: "USD", rails: ["US Account", "RTP"], countries: "United States" },
  { from: "BTC", to: "EUR", rails: ["SEPA", "SEPA Instant"], countries: "Europe" },
  { from: "BTC", to: "BRL", rails: ["PIX"], countries: "Brazil" },
  { from: "BTC", to: "MXN", rails: ["CLABE"], countries: "Mexico" },
  { from: "BTC", to: "INR", rails: ["UPI"], countries: "India" },
  // USDC source
  { from: "USDC", to: "USD", rails: ["US Account", "RTP"], countries: "United States" },
  { from: "USDC", to: "EUR", rails: ["SEPA"], countries: "Europe" },
  { from: "USDC", to: "BRL", rails: ["PIX"], countries: "Brazil" },
  { from: "USDC", to: "BTC", rails: ["Lightning", "Spark"], countries: "Global" },
];

const accountTypes = [
  { type: "US_ACCOUNT", label: "US Bank Account", region: "United States", currency: "USD", icon: "US", desc: "ACH, Wire, RTP" },
  { type: "IBAN", label: "IBAN", region: "Europe / International", currency: "EUR/GBP", icon: "EU", desc: "SEPA, SEPA Instant, Faster Payments" },
  { type: "CLABE", label: "CLABE", region: "Mexico", currency: "MXN", icon: "MX", desc: "18-digit interbank code" },
  { type: "PIX", label: "PIX", region: "Brazil", currency: "BRL", icon: "BR", desc: "CPF, CNPJ, Email, Phone, EVP" },
  { type: "UPI", label: "UPI", region: "India", currency: "INR", icon: "IN", desc: "Unified Payments Interface VPA" },
  { type: "NGN_ACCOUNT", label: "NGN Account", region: "Nigeria", currency: "NGN", icon: "NG", desc: "Bank account + bank name" },
  { type: "GHS_ACCOUNT", label: "GHS Account", region: "Ghana", currency: "GHS", icon: "GH", desc: "Mobile money / bank account" },
  { type: "KES_ACCOUNT", label: "KES Account", region: "Kenya", currency: "KES", icon: "KE", desc: "M-Pesa / bank account" },
  { type: "ZAR_ACCOUNT", label: "ZAR Account", region: "South Africa", currency: "ZAR", icon: "ZA", desc: "Bank account" },
  { type: "PHP_ACCOUNT", label: "PHP Account", region: "Philippines", currency: "PHP", icon: "PH", desc: "Bank account / e-wallet" },
  { type: "SGD_ACCOUNT", label: "PayNow", region: "Singapore", currency: "SGD", icon: "SG", desc: "PayNow instant transfer" },
  { type: "SINPE", label: "SINPE", region: "Costa Rica", currency: "CRC", icon: "CR", desc: "National electronic payment" },
  { type: "LIGHTNING", label: "Lightning Network", region: "Global", currency: "BTC", icon: "BTC", desc: "Layer 2 instant Bitcoin payments" },
  { type: "SPARK_WALLET", label: "Spark Wallet", region: "Global", currency: "BTC", icon: "BTC", desc: "Lightspark Spark protocol" },
  { type: "SOLANA_WALLET", label: "Solana Wallet", region: "Global", currency: "USDC", icon: "SOL", desc: "SPL token transfers" },
  { type: "TRON_WALLET", label: "Tron Wallet", region: "Global", currency: "USDT", icon: "TRX", desc: "TRC-20 token transfers" },
  { type: "POLYGON_WALLET", label: "Polygon Wallet", region: "Global", currency: "USDC", icon: "MATIC", desc: "ERC-20 on Polygon PoS" },
  { type: "BASE_WALLET", label: "Base Wallet", region: "Global", currency: "USDC", icon: "BASE", desc: "ERC-20 on Base L2" },
];

const sepaCountries = [
  "Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czech Republic",
  "Denmark", "Estonia", "Finland", "France", "Germany", "Greece",
  "Hungary", "Iceland", "Ireland", "Italy", "Latvia", "Liechtenstein",
  "Lithuania", "Luxembourg", "Malta", "Monaco", "Netherlands", "Norway",
  "Poland", "Portugal", "Romania", "San Marino", "Slovakia", "Slovenia",
  "Spain", "Sweden",
];

const africanCountries = [
  { country: "Nigeria", currency: "NGN", rail: "NGN Account" },
  { country: "Ghana", currency: "GHS", rail: "GHS Account" },
  { country: "Kenya", currency: "KES", rail: "KES Account" },
  { country: "South Africa", currency: "ZAR", rail: "ZAR Account" },
  { country: "Uganda", currency: "UGX", rail: "UGX Account" },
  { country: "Tanzania", currency: "TZS", rail: "TZS Account" },
  { country: "Senegal", currency: "XOF", rail: "WAEMU" },
  { country: "Ivory Coast", currency: "XOF", rail: "WAEMU" },
  { country: "Mali", currency: "XOF", rail: "WAEMU" },
  { country: "Burkina Faso", currency: "XOF", rail: "WAEMU" },
  { country: "Benin", currency: "XOF", rail: "WAEMU" },
  { country: "Togo", currency: "XOF", rail: "WAEMU" },
  { country: "Niger", currency: "XOF", rail: "WAEMU" },
  { country: "Guinea-Bissau", currency: "XOF", rail: "WAEMU" },
  { country: "Cameroon", currency: "XAF", rail: "CEMAC" },
  { country: "Chad", currency: "XAF", rail: "CEMAC" },
  { country: "Congo", currency: "XAF", rail: "CEMAC" },
];

const asiaCountries = [
  { country: "India", currency: "INR", rail: "UPI" },
  { country: "Philippines", currency: "PHP", rail: "PHP Account" },
  { country: "Singapore", currency: "SGD", rail: "PayNow" },
  { country: "Indonesia", currency: "IDR", rail: "IDR Account" },
  { country: "Thailand", currency: "THB", rail: "PromptPay" },
  { country: "Vietnam", currency: "VND", rail: "VND Account" },
  { country: "Pakistan", currency: "PKR", rail: "PKR Account" },
  { country: "Bangladesh", currency: "BDT", rail: "BDT Account" },
];

const currencyColors: Record<string, string> = {
  USD: "bg-green-500/10 text-green-400 border-green-500/20",
  EUR: "bg-indigo-500/10 text-indigo-400 border-indigo-500/20",
  GBP: "bg-purple-500/10 text-purple-400 border-purple-500/20",
  BRL: "bg-teal-500/10 text-teal-400 border-teal-500/20",
  MXN: "bg-pink-500/10 text-pink-400 border-pink-500/20",
  INR: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  NGN: "bg-lime-500/10 text-lime-400 border-lime-500/20",
  GHS: "bg-yellow-500/10 text-yellow-400 border-yellow-500/20",
  KES: "bg-red-500/10 text-red-400 border-red-500/20",
  ZAR: "bg-orange-500/10 text-orange-400 border-orange-500/20",
  PHP: "bg-rose-500/10 text-rose-400 border-rose-500/20",
  SGD: "bg-cyan-500/10 text-cyan-400 border-cyan-500/20",
  CAD: "bg-red-500/10 text-red-400 border-red-500/20",
  IDR: "bg-fuchsia-500/10 text-fuchsia-400 border-fuchsia-500/20",
  THB: "bg-violet-500/10 text-violet-400 border-violet-500/20",
  CRC: "bg-sky-500/10 text-sky-400 border-sky-500/20",
  BTC: "bg-orange-500/10 text-orange-400 border-orange-500/20",
  USDC: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  USDT: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  XOF: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  XAF: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  UGX: "bg-lime-500/10 text-lime-400 border-lime-500/20",
  TZS: "bg-lime-500/10 text-lime-400 border-lime-500/20",
  VND: "bg-rose-500/10 text-rose-400 border-rose-500/20",
  PKR: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  BDT: "bg-teal-500/10 text-teal-400 border-teal-500/20",
};

type Tab = "corridors" | "countries" | "account-types";

export default function Corridors() {
  const [tab, setTab] = useState<Tab>("corridors");
  const [filter, setFilter] = useState("");

  const filteredCorridors = filter
    ? corridors.filter(
        (c) =>
          c.from.toLowerCase().includes(filter.toLowerCase()) ||
          c.to.toLowerCase().includes(filter.toLowerCase()) ||
          c.countries.toLowerCase().includes(filter.toLowerCase()) ||
          c.rails.some((r) => r.toLowerCase().includes(filter.toLowerCase())),
      )
    : corridors;

  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-[#F8F8F7] tracking-tight">
          Payment Corridors
        </h1>
        <p className="text-sm text-[#8A8A8A] mt-1">
          65+ countries, 20+ currencies, instant settlement on crypto and real-time payment rails
        </p>
      </div>

      {/* Stats Row */}
      <div className="grid grid-cols-4 gap-4 mb-8">
        <div className="bg-[#111111] border border-[#222222] rounded-lg p-5 text-center">
          <div className="text-3xl font-bold text-[#F8F8F7]">65+</div>
          <div className="text-xs text-[#8A8A8A] mt-1">Countries</div>
        </div>
        <div className="bg-[#111111] border border-[#222222] rounded-lg p-5 text-center">
          <div className="text-3xl font-bold text-[#00B3E0]">{accountTypes.length}</div>
          <div className="text-xs text-[#8A8A8A] mt-1">Account Types</div>
        </div>
        <div className="bg-[#111111] border border-[#222222] rounded-lg p-5 text-center">
          <div className="text-3xl font-bold text-emerald-400">{corridors.length}</div>
          <div className="text-xs text-[#8A8A8A] mt-1">Corridors</div>
        </div>
        <div className="bg-[#111111] border border-[#222222] rounded-lg p-5 text-center">
          <div className="text-3xl font-bold text-purple-400">24/7</div>
          <div className="text-xs text-[#8A8A8A] mt-1">Availability</div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="flex gap-1 mb-6 bg-[#111111] border border-[#222222] rounded-lg p-1 w-fit">
        {([
          { key: "corridors", label: "Currency Corridors" },
          { key: "countries", label: "Country Coverage" },
          { key: "account-types", label: "Account Types" },
        ] as { key: Tab; label: string }[]).map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`px-4 py-2 rounded text-sm font-medium transition-colors ${
              tab === t.key
                ? "bg-[#00B3E0]/10 text-[#00B3E0]"
                : "text-[#8A8A8A] hover:text-[#F8F8F7]"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Corridors Tab */}
      {tab === "corridors" && (
        <>
          <div className="mb-4">
            <input
              type="text"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              placeholder="Filter by currency, country, or rail..."
              className="w-full max-w-md bg-[#0A0A0A] border border-[#333333] rounded-lg px-3 py-2 text-[#F8F8F7] text-sm focus:border-[#00B3E0] focus:outline-none"
            />
          </div>
          <div className="bg-[#111111] border border-[#222222] rounded-lg overflow-hidden">
            <table className="w-full">
              <thead>
                <tr className="border-b border-[#222222]">
                  <th className="px-5 py-3 text-left text-xs text-[#8A8A8A] font-medium">From</th>
                  <th className="px-2 py-3"></th>
                  <th className="px-5 py-3 text-left text-xs text-[#8A8A8A] font-medium">To</th>
                  <th className="px-5 py-3 text-left text-xs text-[#8A8A8A] font-medium">Payment Rails</th>
                  <th className="px-5 py-3 text-left text-xs text-[#8A8A8A] font-medium">Coverage</th>
                </tr>
              </thead>
              <tbody>
                {filteredCorridors.map((c, i) => (
                  <tr key={i} className="border-b border-[#222222]/50 hover:bg-white/[0.02]">
                    <td className="px-5 py-3">
                      <span
                        className={`inline-flex items-center px-2.5 py-1 rounded text-xs font-bold border ${currencyColors[c.from] || "bg-[#222222] text-[#8A8A8A] border-[#333333]"}`}
                      >
                        {c.from}
                      </span>
                    </td>
                    <td className="px-2 py-3">
                      <svg
                        className="w-4 h-4 text-[#555555]"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
                        />
                      </svg>
                    </td>
                    <td className="px-5 py-3">
                      <span
                        className={`inline-flex items-center px-2.5 py-1 rounded text-xs font-bold border ${currencyColors[c.to] || "bg-[#222222] text-[#8A8A8A] border-[#333333]"}`}
                      >
                        {c.to}
                      </span>
                    </td>
                    <td className="px-5 py-3">
                      <div className="flex flex-wrap gap-1.5">
                        {c.rails.map((r) => (
                          <span
                            key={r}
                            className="text-[11px] px-2 py-0.5 rounded bg-[#1a1a1a] text-[#8A8A8A] font-mono"
                          >
                            {r}
                          </span>
                        ))}
                      </div>
                    </td>
                    <td className="px-5 py-3">
                      <span className="text-xs text-[#8A8A8A]">{c.countries}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* Countries Tab */}
      {tab === "countries" && (
        <div className="space-y-8">
          {/* Europe */}
          <div>
            <h2 className="text-sm font-semibold text-[#F8F8F7] mb-3 flex items-center gap-2">
              <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-bold border ${currencyColors.EUR}`}>EUR</span>
              Europe (SEPA) - {sepaCountries.length} Countries
            </h2>
            <div className="bg-[#111111] border border-[#222222] rounded-lg p-5">
              <div className="flex flex-wrap gap-2">
                {sepaCountries.map((c) => (
                  <span key={c} className="text-xs px-3 py-1.5 rounded-lg bg-[#1a1a1a] text-[#CCCCCC] border border-[#333333]">
                    {c}
                  </span>
                ))}
              </div>
              <p className="text-xs text-[#8A8A8A] mt-3">All via SEPA / SEPA Instant using IBAN + SWIFT BIC</p>
            </div>
          </div>

          {/* Africa */}
          <div>
            <h2 className="text-sm font-semibold text-[#F8F8F7] mb-3">
              Africa - {africanCountries.length} Countries
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
              {africanCountries.map((c) => (
                <div key={c.country} className="bg-[#111111] border border-[#222222] rounded-lg p-4">
                  <div className="text-sm font-medium text-[#F8F8F7]">{c.country}</div>
                  <div className="flex items-center gap-2 mt-1">
                    <span className={`text-[11px] px-1.5 py-0.5 rounded border font-bold ${currencyColors[c.currency] || "bg-[#222222] text-[#8A8A8A] border-[#333333]"}`}>
                      {c.currency}
                    </span>
                    <span className="text-[11px] text-[#666666] font-mono">{c.rail}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Asia-Pacific */}
          <div>
            <h2 className="text-sm font-semibold text-[#F8F8F7] mb-3">
              Asia-Pacific - {asiaCountries.length} Countries
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
              {asiaCountries.map((c) => (
                <div key={c.country} className="bg-[#111111] border border-[#222222] rounded-lg p-4">
                  <div className="text-sm font-medium text-[#F8F8F7]">{c.country}</div>
                  <div className="flex items-center gap-2 mt-1">
                    <span className={`text-[11px] px-1.5 py-0.5 rounded border font-bold ${currencyColors[c.currency] || "bg-[#222222] text-[#8A8A8A] border-[#333333]"}`}>
                      {c.currency}
                    </span>
                    <span className="text-[11px] text-[#666666] font-mono">{c.rail}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Americas */}
          <div>
            <h2 className="text-sm font-semibold text-[#F8F8F7] mb-3">
              Americas - 5 Countries
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
              {[
                { country: "United States", currency: "USD", rail: "ACH / Wire / RTP" },
                { country: "Canada", currency: "CAD", rail: "CAD Account" },
                { country: "Mexico", currency: "MXN", rail: "CLABE" },
                { country: "Brazil", currency: "BRL", rail: "PIX" },
                { country: "Costa Rica", currency: "CRC", rail: "SINPE" },
              ].map((c) => (
                <div key={c.country} className="bg-[#111111] border border-[#222222] rounded-lg p-4">
                  <div className="text-sm font-medium text-[#F8F8F7]">{c.country}</div>
                  <div className="flex items-center gap-2 mt-1">
                    <span className={`text-[11px] px-1.5 py-0.5 rounded border font-bold ${currencyColors[c.currency] || "bg-[#222222] text-[#8A8A8A] border-[#333333]"}`}>
                      {c.currency}
                    </span>
                    <span className="text-[11px] text-[#666666] font-mono">{c.rail}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Crypto */}
          <div>
            <h2 className="text-sm font-semibold text-[#F8F8F7] mb-3">
              Crypto - Global Coverage
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <div className="bg-[#111111] border border-orange-500/20 rounded-lg p-5">
                <div className="text-sm font-medium text-orange-400 mb-2">Bitcoin (BTC)</div>
                <div className="space-y-1 text-xs text-[#8A8A8A]">
                  <div>Lightning Network - &lt;1 second</div>
                  <div>Spark Protocol - &lt;1 second</div>
                </div>
              </div>
              <div className="bg-[#111111] border border-blue-500/20 rounded-lg p-5">
                <div className="text-sm font-medium text-blue-400 mb-2">USDC</div>
                <div className="space-y-1 text-xs text-[#8A8A8A]">
                  <div>Solana - &lt;30 seconds</div>
                  <div>Base (L2) - &lt;30 seconds</div>
                  <div>Polygon - &lt;30 seconds</div>
                </div>
              </div>
              <div className="bg-[#111111] border border-emerald-500/20 rounded-lg p-5">
                <div className="text-sm font-medium text-emerald-400 mb-2">USDT</div>
                <div className="space-y-1 text-xs text-[#8A8A8A]">
                  <div>Tron (TRC-20) - &lt;30 seconds</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Account Types Tab */}
      {tab === "account-types" && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {accountTypes.map((a) => (
            <div
              key={a.type}
              className="bg-[#111111] border border-[#222222] rounded-lg p-4 hover:border-[#444444] transition-colors"
            >
              <div className="flex items-center gap-3 mb-2">
                <span
                  className={`text-xs font-bold px-2 py-0.5 rounded border ${currencyColors[a.currency.split("/")[0]] || "bg-[#222222] text-[#8A8A8A] border-[#333333]"}`}
                >
                  {a.icon}
                </span>
                <div className="text-sm font-medium text-[#F8F8F7]">{a.label}</div>
              </div>
              <div className="text-xs text-[#8A8A8A]">{a.region}</div>
              <div className="text-xs text-[#666666] mt-1">{a.desc}</div>
              <div className="text-[11px] font-mono text-[#555555] mt-2">{a.type}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
